import { Scale } from "../../../utils/Scale"

export class SvdPos {

    static smokeBoxX = () => Scale.width() * 0.07
    static boxY = () => Scale.height() * 0.35
    static bodyY = () => Scale.height() * 0.44
    static lungsY = () => Scale.height() * 0.59
    static smokeY = () => Scale.height() * 0.529

    static vaporBoxX = () => Scale.width() * 0.53

    static smokeTitleX = () => Scale.width() * 0.13
    static vaporTitleX = () => Scale.width() * 0.6
    static titleY = () => Scale.height() * 0.87

    static smokeLeftBodyX = () => SvdPos.smokeBoxX() + Scale.width() * 0.03
    static smokeRightBodyX = () => SvdPos.smokeBoxX() + Scale.width() * 0.22

    static vaporLeftBodyX = () => SvdPos.vaporBoxX() + Scale.width() * 0.03
    static vaporRightBodyX = () => SvdPos.vaporBoxX() + Scale.width() * 0.22

    private static lungXOffset = () => 0.032

    static smokeLeftLungsX = () => SvdPos.smokeLeftBodyX() + Scale.width() * SvdPos.lungXOffset()
    static smokeRightLungsX = () => SvdPos.smokeRightBodyX() + Scale.width() * SvdPos.lungXOffset()

    static vaporLeftLungsX = () => SvdPos.vaporLeftBodyX() + Scale.width() * SvdPos.lungXOffset()
    static vaporRightLungsX = () => SvdPos.vaporRightBodyX() + Scale.width() * SvdPos.lungXOffset()

    static cigX = () => Scale.width() * 0.19
    static cigY = () => Scale.height() * 0.452

    static vapeX = () => Scale.width() * 0.65
    static vapeY = () => Scale.height() * 0.53

    static cigSmokeCloudX = () => Scale.width() * 0.225
    static cigSmokeCloudY = () => Scale.height() * 0.54

    static vapeSmokeX = () => Scale.width() * 0.65
    static vapeSmokeY = () => Scale.height() * 0.54

    private static smokeXOffset = () => 0.032

    static smokeSmokeLeft = () => SvdPos.smokeLeftBodyX() + Scale.width() * SvdPos.smokeXOffset()
    static smokeSmokeRight = () => SvdPos.smokeRightBodyX() + Scale.width() * SvdPos.smokeXOffset()
    static vaporSmokeLeft = () => SvdPos.vaporLeftBodyX() + Scale.width() * SvdPos.smokeXOffset()
    static vaporSmokeRight = () => SvdPos.vaporRightBodyX() + Scale.width() * SvdPos.smokeXOffset()

}
